import React, { useState } from "react";
import { Modal, Row, Col } from "react-bootstrap";
import { Tooltip } from "@mui/material";
import config from "../../config";
import rainbow from '../../assets/images/rainbow.png'
import { imgPath } from "../../utils/imagePath";
import PropTypes from "prop-types";

function formatText(text) {
  if (typeof text !== "string" || text.trim() === "") {
    return text || null;
  }

  return text.split("\r\n").map((line, index) => (
    <React.Fragment key={`${line}-${index}`}>
      {line}
      <br />
    </React.Fragment>
  ));
}

const Details = (props) => {

  const { userdata, getFieldValueAndStatus } = props;
  const inputString = userdata?.all_main_area
  const inputSubString = userdata?.all_sub_area
  const domain = inputString ? inputString.split("||") : [];
  const subDomain = inputSubString ? inputSubString.split("||") : [];
  const [showMentalHealthTooltip, setShowMentalHealthTooltip] = useState(false);
  const [showCoachTooltip, setShowCoachTooltip] = useState(false);
  const [showLgtbqTooltip, setShowLgtbqTooltip] = useState(false);
  const [showRelationshipTooltip, setShowRelationshipTooltip] = useState(false);

  let availabilityStatus = null;

  // if (getFieldValueAndStatus('availability')) {
  if (userdata?.is_reached_limit === 0) {
    if (userdata?.user_availability_check?.availability === 1) {
      availabilityStatus = (
        <span className="AvailabilityStatus m-3">Available</span>
      );
    } else {
      availabilityStatus = (
        <span className="UnavailabilityStatus m-3">Unavailable</span>
      );
    }
  } else {
    availabilityStatus = (
      <span className="UnavailabilityStatus m-3">Unavailable</span>
    );
  }
  // }

  // Get label ONLY from API
  const getLabel = (key) => {

    // console.log("userdata?.steps_labels::::::::::",userdata?.steps_labels)

    // FIRST PRIORITY -> API dynamic labels
    if (userdata?.steps_labels?.[key]) {
      return userdata.steps_labels[key];
    }

    // SECOND PRIORITY
    if (userdata?.fields?.[key]?.label) {
      return userdata.fields[key].label;
    }

    // THIRD PRIORITY
    if (Array.isArray(userdata?.reg_feilds)) {

      for (const step of userdata.reg_feilds) {

        if (Array.isArray(step.reg_feilds)) {

          const found = step.reg_feilds.find(
            (f) => f.reg_key === key
          );

          if (found?.label) {
            return found.label;
          }
        }
      }
    }

    // FALLBACK
    return key
      .replaceAll("_", " ")
      .split(" ")
      .map(
        (word) =>
          word.charAt(0).toUpperCase() +
          word.slice(1)
      )
      .join(" ");
  };

  const renderField = (key, value) => {
    if (
      value === null ||
      value === undefined ||
      value === "" ||
      value === "null" ||
      value === "undefined"
    )
      return null;

    const label = getLabel(key);
    if (!label) return null;

    return (
      <>
        <p className="mt-2">
          <strong>{label == "Past Board Roles" ? "Current / Past Board Roles" : label}:</strong>
        </p>
        <p>{value}</p>
      </>
    );
  };

  const getDynamicFieldValue = (key) => {
    if (userdata?.reg_fields && Object.hasOwn(userdata.reg_fields, key)) {
      return userdata.reg_fields[key];
    }

    if (userdata?.[key] !== undefined) {
      return userdata[key];
    }

    if (key === "objective") {
      return userdata?.all_objective;
    }

    return undefined;
  };

  const fullName = userdata?.full_name ?? [
    getDynamicFieldValue("first_name"),
    getDynamicFieldValue("last_name"),
  ]
    .filter(Boolean)
    .join(" ");

  const position = getDynamicFieldValue("position");
  const organization = getDynamicFieldValue("organization");
  const objective = getDynamicFieldValue("objective");
  const country = getDynamicFieldValue("country") ?? userdata?.country;
  const hasPosition = position && position !== "undefined";
  const hasOrganization = organization && organization !== "undefined";
  const hasObjective = objective && objective !== "undefined";
  const showPosition = getFieldValueAndStatus('position') || hasPosition;
  const showOrganization = getFieldValueAndStatus('organization') || hasOrganization;
  const showName = Boolean(fullName);
  const showCountry = Boolean(country || userdata?.country_image_path);

  const isDynamicFieldSuppressed = (key) => {
    const suppressed = new Set([
      "image",
      "is_privacy",
      "first_name",
      "last_name",
      "country",
      "country_image_path",
      "lgbtq_discussion",
      "number_of_mentoring_engagements",
      "first_domain",
      "mf_mental_health",
      "mf_certified_coach",
      "organization",
      "position",
      "user_availability_check",
      "is_reached_limit",
      "total_completed_mentees",
      "total_ongoing_mentees",
      "fields",
      "reg_feilds",
      "labels",
      "availability",
      "steps_labels",
      "sub_domains",
      "all_sub_area",
    ]);

    if (suppressed.has(key)) return true;
    if (key === "position" && userdata?.position) return true;
    if (key === "organization" && userdata?.organization) return true;
    if (key === "full_name" && userdata?.full_name) return true;
    if ((key === "all_main_area" || key === "all_sub_area") && userdata?.all_main_area) return true;
    if (key === "linkedin" && userdata?.linkedin) return true;
    if (key === "resume" && userdata?.resume) return true;
    return false;
  };

  const isEmptyValue = (value) =>
    value === null ||
    value === undefined ||
    value === "" ||
    value === "null" ||
    value === "undefined" ||
    (Array.isArray(value) && value.length === 0);

  const renderArrayField = (key, arr, field = "title") => {
    if (!arr) return null;

    const safeArray = Array.isArray(arr) ? arr : [arr];
    if (safeArray.length === 0) return null;

    const label = getLabel(key);
    if (!label) return null;

    return (
      <>
        <p className="mt-2">
          <strong>{label}:</strong>
        </p>
        <p>
          {safeArray.map((item, index) => {
            let text = "";
            if (item !== null && item !== undefined) {
              if (typeof item === "object") {
                text = item[field] ?? item.title ?? item.name ?? item.label ?? JSON.stringify(item);
              } else {
                text = item;
              }
            }
            return (
              <span key={item?.id ?? `${key}-${index}`} className="tagPoint">
                {text}
              </span>
            );
          })}
        </p>
      </>
    );
  };

  const dynamicFieldReservedKeys = new Set([
    "image",
    "is_privacy",
    "first_name",
    "last_name",
    "country",
    "country_image_path",
    "user_availability_check",
    "is_reached_limit",
    "availability",
    "mf_mental_health",
    "mf_certified_coach",
    "lgbtq_discussion",
    "total_completed_mentees",
    "total_ongoing_mentees",
    "id",
    "status",
    "date",
    "created_at",
    "is_same_program",
    "is_relationship",
    "is_relationship_new",
    "is_mentor_terminate",
    "reg_fields",
    "reg_feilds",
    "fields",
    "labels",
    "steps_labels"
  ]);

  const getDynamicFieldKeys = () => {
    const orderedKeys = [];

    if (Array.isArray(userdata?.reg_feilds)) {
      orderedKeys.push(
        ...userdata.reg_feilds.flatMap((step) =>
          Array.isArray(step.reg_feilds)
            ? step.reg_feilds.map((field) => field.reg_key)
            : []
        )
      );
    } else if (userdata?.reg_fields && typeof userdata.reg_fields === "object") {
      orderedKeys.push(...Object.keys(userdata.reg_fields));
    }

    if (userdata && typeof userdata === "object") {
      const topLevelKeys = Object.keys(userdata).filter(
        (key) =>
          !dynamicFieldReservedKeys.has(key) &&
          !orderedKeys.includes(key)
      );
      orderedKeys.push(...topLevelKeys);
    }

    return orderedKeys;
  };

  const dynamicFieldKeys = getDynamicFieldKeys().filter((key) => {
    if (isDynamicFieldSuppressed(key)) return false;
    return !isEmptyValue(getDynamicFieldValue(key));
  });

  const dynamicFieldSet = new Set(dynamicFieldKeys);

  const downloadResume = (e, url) => {
    e.preventDefault();
    if (!url) return;
    window.open(url, "_blank");
  };

  const renderDynamicField = (key) => {
    const value = getDynamicFieldValue(key);
    // if (isEmptyValue(value) || (key !== "objective" && !getFieldValueAndStatus(key))) return null;

    if (
      isEmptyValue(value) ||
      (key !== "objective" && !getFieldValueAndStatus(userdata, key))
    ) {
      return null;
    }

    // if (key === "domains" || key === "all_main_area") {
    //   return (
    //     <>
    //       {renderArrayField(
    //         key,
    //         key === "domains" ? domain : value?.split?.("||") || []
    //       )}

    //       {subDomain?.length > 0 &&
    //         renderArrayField("sub_domains", subDomain)}
    //     </>
    //   );
    // }

    if (key === "linkedin") {
      const href = typeof value === "string" ? value : value?.url;
      if (!href) return null;
      const normalizedHref = href.startsWith("http") ? href : `https://${href}`;
      return (
        <div className="linkedin_btn">
          <a
            href={normalizedHref}
            className="link_btn btn btn_red me-0"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={imgPath + "linkedin.png"}
              className="me-2 bg-white"
              alt="LinkedIn"
            />
            {" "}
            Linkedin Profile
          </a>
        </div>
      );
    }

    if (key === "resume") {
      const resumeUrl = typeof value === "string" ? value : value?.url;

      if (!resumeUrl) return null;

      return (
        <div className="linkedin_btn mt-2">
          <a
            href="resumeUrl"
            className="link_btn btn btn_red me-0"
            onClick={(e) => downloadResume(e, resumeUrl)}
          >
            <i className="fa fa-file-pdf-o me-2"></i>{" "}
            Resume
          </a>
        </div>
      );
    }

    if (Array.isArray(value)) {
      return renderArrayField(key, value);
    }

    if (typeof value === "object") {
      const nested = value.title || value.name || value.label || JSON.stringify(value);
      return renderField(key, nested);
    }

    const valueText = typeof value === "string" && value.includes("||")
      ? value.split("||").join(", ")
      : value;

    if (key === "about") {
      return renderField(key, formatText(valueText));
    }

    return renderField(key, valueText);
  };

  const totalMentoringEngagements =
    Number.parseInt(getDynamicFieldValue('total_completed_mentees') || 0, 10) +
    Number.parseInt(getDynamicFieldValue('total_ongoing_mentees') || 0, 10);

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton className="details-modal-header"></Modal.Header>
      <Modal.Body style={{ maxHeight: '60vh', overflowY: 'scroll', overflowX: 'hidden', }}>
        <Row className="mentor_detail">
          <Col md={4}>
            <div className="mentor_pic">
              {availabilityStatus}
              <img
                src={
                  userdata?.image ||
                  getDynamicFieldValue("image") ||
                  imgPath + "mentor_women_two.png"
                }
                alt={fullName || "user"}
              />
              <div className="mentor_name2">
                <div className="mentor_info">
                  {showCountry && (
                    <span>
                      {userdata?.country_image_path && (
                        <img src={userdata?.country_image_path} alt="professional consultants for women" className="country_flag" />
                      )}
                    </span>
                  )}
                  {showName && <h3>{fullName}</h3>}
                  {showPosition && hasPosition && <h5><span className="m-0">{position}</span></h5>}
                  {showOrganization && hasOrganization &&
                    <h5>
                      {organization === "undefined" || !organization
                        ? ""
                        : organization}
                    </h5>
                  }

                  <div className="extar_info_link">
                    <ul className="px-0">
                      {Number(getDynamicFieldValue('mf_mental_health')) === 1 && (
                        <li>
                          <Tooltip
                            size="4xl"
                            title={<h5>{config?.mf_mental_health}</h5>}
                            describeChild
                            arrow
                            open={showMentalHealthTooltip}
                            onClose={() => setShowMentalHealthTooltip(false)}
                          >
                            <button
                              type="button"
                              style={{ border: "white", backgroundColor: "white" }}
                              onClick={() => setShowMentalHealthTooltip(true)}
                            >
                              <img
                                src={imgPath + "usermind.svg"}
                                alt="Mental Health"
                              />
                            </button>
                          </Tooltip>
                        </li>
                      )}
                      {Number(getDynamicFieldValue('mf_certified_coach')) === 1 && (
                        <li>
                          <Tooltip
                            size="4xl"
                            title={<h5>{config?.mf_certified_coach}</h5>}
                            describeChild
                            arrow
                            open={showCoachTooltip}
                            onClose={() => setShowCoachTooltip(false)}
                          >
                            <button
                              type="button"
                              style={{ border: "white", backgroundColor: "white" }}
                              onClick={() => setShowCoachTooltip(true)}
                            >
                              <img
                                src={imgPath + "useraward.svg"}
                                alt="Certified Coach"
                              />
                            </button>
                          </Tooltip>
                        </li>
                      )}
                      {Number(getDynamicFieldValue('lgbtq_discussion')) === 1 && (
                        <li>
                          <Tooltip
                            size="4xl"
                            title={<h5>{config?.LGBTQ_discussion}</h5>}
                            describeChild
                            arrow
                            open={showLgtbqTooltip}
                            onClose={() => setShowLgtbqTooltip(false)}
                          >
                            <button
                              type="button"
                              style={{ border: "white", backgroundColor: "white" }}
                              onClick={() => setShowLgtbqTooltip(true)}
                            >
                              <img
                                src={rainbow}
                                style={{ width: "47px" }}
                                alt="LGBTQ+ Discussion"
                              />
                            </button>
                          </Tooltip>
                        </li>
                      )}

                      {Number(getDynamicFieldValue('number_of_mentoring_engagements')) === 1 &&
                        totalMentoringEngagements > 0 && (
                          <li>
                            <Tooltip
                              size="4xl"
                              title={<h5>{config?.number_of_mentoring_engagements} {Number.parseInt(getDynamicFieldValue('total_completed_mentees') || 0, 10) + Number.parseInt(getDynamicFieldValue('total_ongoing_mentees') || 0, 10)}</h5>}
                              describeChild
                              arrow
                              open={showRelationshipTooltip}
                              onClose={() => setShowRelationshipTooltip(false)}
                            >
                              <button
                                type="button"
                                className="bg-transparent border-0 p-0"
                                onClick={() => setShowRelationshipTooltip(true)}
                                aria-label="Number of mentoring engagements"
                              >
                                <img
                                  alt=""
                                  src={imgPath + "completed_relationship.png"}
                                />
                              </button>
                            </Tooltip>
                          </li>
                        )}

                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col md={8}>
            <div className="tag_outer">

              {dynamicFieldKeys.length > 0 &&
                dynamicFieldKeys.map((key) => {
                  if (key === "all_sub_area" || key === "sub_domains") {
                    return null;
                  }

                  return (
                    <React.Fragment key={key}>
                      {renderDynamicField(key)}

                      {(key === "all_main_area" || key === "domains") &&
                        subDomain?.length > 0 &&
                        renderArrayField("sub_domains", subDomain)}
                    </React.Fragment>
                  );
                })}

              {!dynamicFieldSet.has("all_main_area") &&
                !dynamicFieldSet.has("domains") &&
                getFieldValueAndStatus("domains") && (
                  <>
                    {renderArrayField("domains", domain)}
                    {renderArrayField("sub_domains", subDomain)}
                  </>
                )}

              {!dynamicFieldSet.has("linkedin") &&
                getFieldValueAndStatus('linkedin') && (
                  <div className="linkedin_btn">
                    <a
                      href={userdata.linkedin?.startsWith('http') ? userdata.linkedin : `https://${userdata.linkedin}`}
                      className="link_btn btn btn_red me-0"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={imgPath + "linkedin.png"}
                        className="me-2 bg-white"
                        alt="LinkedIn"
                      />{" "}
                      Linkedin Profile
                    </a>
                  </div>
                )}

              {/* {!dynamicFieldSet.has("resume") &&
                getFieldValueAndStatus('resume') &&
                userdata.resume && <a href={userdata.resume}>Resume</a>} */}

              {!dynamicFieldSet.has("dob") &&
                getFieldValueAndStatus('dob') &&
                renderField('dob', userdata?.dob)}

              {!dynamicFieldSet.has("university_partners_name") &&
                getFieldValueAndStatus('university_partners_id') &&
                renderField('university_partners_name', userdata?.university_partners_name)
              }

              {!dynamicFieldSet.has("industry_name") &&
                getFieldValueAndStatus('industry_id') &&
                renderField('industry_name', userdata?.industry_name)
              }

              {!dynamicFieldSet.has("year_of_graduation") &&
                getFieldValueAndStatus('year_of_graduation') &&
                renderField('year_of_graduation', userdata?.year_of_graduation)
              }

              {!dynamicFieldSet.has("sim_student_id") &&
                getFieldValueAndStatus('sim_student_id') &&
                renderField('sim_student_id', userdata?.sim_student_id)
              }

              {!dynamicFieldSet.has("number") &&
                getFieldValueAndStatus('number') &&
                renderField('number', userdata?.number)
              }

              {!dynamicFieldSet.has("objective") &&
                hasObjective &&
                renderField('objective', objective)
              }

              {!dynamicFieldSet.has("language") &&
                getFieldValueAndStatus('language') &&
                renderField('language', userdata?.language)
              }

              {!dynamicFieldSet.has("experience_levels") &&
                getFieldValueAndStatus('experience_levels') &&
                renderArrayField('experience_levels', userdata?.experience_levels)
              }

              {!dynamicFieldSet.has("accredited_director") &&
                getFieldValueAndStatus('accredited_director') &&
                renderArrayField('accredited_director', userdata?.accredited_director_data)
              }

              {!dynamicFieldSet.has("board_entity_type") &&
                getFieldValueAndStatus('board_entity_type') &&
                renderArrayField('board_entity_type', userdata?.board_entity_type_data)
              }

              {!dynamicFieldSet.has("course_completed") &&
                getFieldValueAndStatus('course_completed') &&
                renderArrayField('course_completed', userdata?.course_completed_data)
              }

              {!dynamicFieldSet.has("board_roles_data") &&
                getFieldValueAndStatus('past_board_roles') && userdata?.board_roles_data?.length > 0 && (
                  <>
                    <p className="mt-2"><strong>{userdata?.steps_labels?.past_board_roles}</strong></p>
                    <p>
                      {userdata.board_roles_data.map((item, index) => (
                        <span key={item.rep_board_title + index} className="tagPoint">
                          <strong>{getLabel('rep_company_name')}:</strong> {item.rep_company_name} <strong>{getLabel('rep_board_title')}:</strong> {item.rep_board_title}
                        </span>
                      ))}
                    </p>
                  </>
                )}

              {!dynamicFieldSet.has("gender") &&
                getFieldValueAndStatus('gender') &&
                renderField('gender', userdata?.gender)
              }

              {!dynamicFieldSet.has("years_of_board_experience_data") &&
                getFieldValueAndStatus('years_of_board_experience') &&
                renderField('years_of_board_experience', userdata?.years_of_board_experience_data)
              }

              {!dynamicFieldSet.has("indicate_board_experience_level_data") &&
                getFieldValueAndStatus('indicate_board_experience_level') &&
                renderField('indicate_board_experience_level', userdata?.indicate_board_experience_level_data)
              }

              {!dynamicFieldSet.has("programmes_data") &&
                getFieldValueAndStatus('programmes') &&
                renderArrayField('programmes', userdata?.programmes_data, 'program')
              }

              {!dynamicFieldSet.has("about") &&
                getFieldValueAndStatus('about') &&
                userdata?.about &&
                renderField('about', formatText(userdata.about))
              }

              {!dynamicFieldSet.has("past_board_roles_data") &&
                getFieldValueAndStatus('past_board_roles_data') &&
                renderArrayField('past_board_roles_data', userdata?.past_board_roles_data, 'rep_board_title')
              }

            </div>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

Details.propTypes = {
  userdata: PropTypes.shape({
    full_name: PropTypes.string,
    position: PropTypes.string,
    organization: PropTypes.string,
    country_image_path: PropTypes.string,
    image: PropTypes.string,
    mf_mental_health: PropTypes.number,
    mf_certified_coach: PropTypes.number,
    lgbtq_discussion: PropTypes.number,
    total_completed_mentees: PropTypes.number,
    total_ongoing_mentees: PropTypes.number,
    linkedin: PropTypes.string,
    resume: PropTypes.string,
    dob: PropTypes.string,
    university_partners_name: PropTypes.string,
    industry_name: PropTypes.string,
    year_of_graduation: PropTypes.string,
    sim_student_id: PropTypes.string,
    number: PropTypes.string,
    all_objective: PropTypes.string,
    language: PropTypes.string,
    experience_levels: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
      })
    ),
    programmes_data: PropTypes.arrayOf(
      PropTypes.shape({
        program: PropTypes.string,
      })
    ),
    gender: PropTypes.string,
    about: PropTypes.string,
    past_board_roles_data: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        rep_company_name: PropTypes.string,
        rep_board_title: PropTypes.string,
        rep_start_date: PropTypes.string,
        rep_end_date: PropTypes.string,
      })
    ),
    all_main_area: PropTypes.string,
    all_sub_area: PropTypes.string,
    is_reached_limit: PropTypes.number,
    user_availability_check: PropTypes.shape({
      availability: PropTypes.number,
    }),
    accredited_director_data: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string
      })
    ),

    board_entity_type_data: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string
      })
    ),

    course_completed_data: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string
      })
    ),

    board_roles_data: PropTypes.arrayOf(
      PropTypes.shape({
        rep_board_title: PropTypes.string,
        rep_company_name: PropTypes.string,
        rep_start_date: PropTypes.string,
        rep_end_date: PropTypes.string
      })
    ),
    years_of_board_experience_data: PropTypes.string,
    indicate_board_experience_level_data: PropTypes.string,
    reg_feilds: PropTypes.arrayOf(
      PropTypes.shape({
        reg_feilds: PropTypes.arrayOf(
          PropTypes.shape({
            reg_key: PropTypes.string,
            label: PropTypes.string,
          }))
      })
    ),
    fields: PropTypes.objectOf(
      PropTypes.shape({
        label: PropTypes.string,
      })
    ),
    reg_fields: PropTypes.objectOf(PropTypes.any),
    labels: PropTypes.objectOf(PropTypes.string),
    steps_labels: PropTypes.func,
    country: PropTypes.string,
  }).isRequired,
  getFieldValueAndStatus: PropTypes.func.isRequired,
};

export default Details;
